// extracted by mini-css-extract-plugin
export default {"link":"LoadingHome_link__4NqUF","mobile":"LoadingHome_mobile__wkymH","desktop":"LoadingHome_desktop__UODjA"};